import '../style.scss'
import { useContext, useState } from "react"
import ApiContext from 'src/provider/API/call-service'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { FiChevronDown } from "react-icons/fi"
import { RiCloseFill } from "react-icons/ri"
import { AbsoluteContainer, AppLabel, AppSpan, Button, CustomContainer, FixedContainer, FlexColumn, FlexRow, Form, FormGroup, FormGroupWithIcon, SidePopupContainer } from "src/style"
import { VscSmiley } from 'react-icons/vsc'
import { IoDocumentTextOutline, IoImageOutline } from 'react-icons/io5'
import { ImAttachment } from 'react-icons/im'
import helpers from 'src/utils/helpers'


export const ServiceRequestAndDispute: React.FC<any> = ({type, close}) => {
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({
        serviceType: '', description: '', createdBy: '',
        assignedTo: '', assigneeDepartment: '', priority: '',
        customerName: '', customerEmail: '', title: ''
    })

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (!helpers.validateEmail(input.customerEmail)) return notifier.show('Kindly provide a valid customer email', 'Validation Response')
        
        let issueType = type === 'serviceRequest' ? 'Request' : 'Dispute'
        await API.logServiceRequestOrDispute({...input, issueType})
        close()
    }
    
    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FixedContainer 
                className="service-request-container" 
                zIndex="9" radius="0.8" bgColor="#ffffff"
                topPadding="1.5" height='85' hUnit='%' width="71.5"
            >
                <Form style={{height: '100%'}} onSubmit={handleSubmit}>
                    <CustomContainer 
                        height="85" hUnit="%" padding="2.5" overflow="auto" topPadding="1"
                    >
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel textSize="2" fontWeight="600">{type === 'serviceRequest' ? 'Service Request' : 'Dispute'}</AppLabel>
                            <AbsoluteContainer top="0" right="0" onClick={close}>
                                <RiCloseFill className='close-icon' />
                            </AbsoluteContainer>
                        </FlexRow>
                        <FormGroup bottomMargin="1.5">
                            <label>Customer name</label>
                            <input 
                                placeholder='Customer name'
                                name='customerName'
                                value={input.customerName}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>
                        <FormGroup bottomMargin="1.5">
                            <label>Customer email</label>
                            <input 
                                placeholder='Customer email'
                                name='customerEmail'
                                value={input.customerEmail}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>
                        <FormGroupWithIcon bottomMargin='1.5'>
                            <label>Service type</label>
                            <div className="input-with-icon">
                                <select 
                                    name="serviceType" 
                                    style={{color: input.serviceType ? '#494949' : '#999'}}
                                    value={input.serviceType}
                                    onChange={handleInput}
                                    required
                                >
                                    <option value="">Select type</option>
                                    <option value='Type 1'>Type 1</option>
                                    <option value='Type 2'>Type 2</option>
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                        <FormGroup bottomMargin="1.5">
                            <label>Subject</label>
                            <input 
                                placeholder='Enter Subject'
                                name='title'
                                value={input.title}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>
                        <FormGroupWithIcon bottomMargin='1.5'>
                            <label>Service request created by</label>
                            <div className="input-with-icon">
                                <select 
                                    name="createdBy" 
                                    style={{color: input.createdBy ? '#494949' : '#999'}}
                                    value={input.createdBy}
                                    onChange={handleInput}
                                    required
                                >
                                    <option value="">Select name</option>
                                    <option value='Ridwan Kolawole'>Ridwan Kolawole</option>
                                    <option value='Chijindu Amadi'>Chijindu Amadi</option>
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                        <FlexRow gap="1.5" justifyContent="space-between" bottomMargin="1.5">
                            <FormGroup bottomMargin="0" width="48.5">
                                <label>Assigned to</label>
                                <input 
                                    placeholder='Enter name'
                                    name='assignedTo'
                                    value={input.assignedTo}
                                    onChange={handleInput}
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin="0" width="48.5">
                                <label>Department of assignee</label>
                                <input 
                                    placeholder='Enter department'
                                    name='assigneeDepartment'
                                    value={input.assigneeDepartment}
                                    onChange={handleInput}
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FormGroupWithIcon bottomMargin='1.5'>
                            <label>Priority</label>
                            <div className="input-with-icon">
                                <select 
                                    name="priority" 
                                    style={{color: input.priority ? '#494949' : '#999'}}
                                    value={input.priority}
                                    onChange={handleInput}
                                    required
                                >
                                    <option value="">Select priority</option>
                                    <option value='Low'>Low</option>
                                    <option value='Medium'>Medium</option>
                                    <option value='High'>High</option>
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                        <FormGroup bottomMargin="0">
                            <label>Information</label>
                            <CustomContainer 
                                height="16.3" radius="0.6" bgColor="#EDF2F7"
                                padding="1.5"
                            >
                                <textarea 
                                    className="custom-textarea" 
                                    name='description'
                                    value={input.description}
                                    onChange={handleInput}
                                    required
                                />
                                <AbsoluteContainer bottom="0" left="0" width="100" sizeUnit="%">
                                    <FlexRow width="auto" sizeUnit="" gap="2" padding='1.5' bottomPadding='1'>
                                        <VscSmiley className="chat-input-icons" />
                                        <IoImageOutline className="chat-input-icons" />
                                        <ImAttachment className="chat-input-icons" />
                                        <IoDocumentTextOutline className="chat-input-icons" />
                                    </FlexRow>
                                </AbsoluteContainer>
                            </CustomContainer>
                        </FormGroup>
                    </CustomContainer>
                    <FlexColumn height="15" hUnit="%" justifyContent="flex-end">
                        <FlexRow justifyContent="flex-end" padding="2.5">
                            <Button
                                    width='8.1' borderColor='#E4ECF7' height='3.6'
                                    hoverBgColor='#E4ECF7' hoverColor='#505780'
                                    bgColor="#ffffff" color="#505780" rightMargin="1"
                                    radius="0.6" titleSize="1.2"
                                    onClick={close}
                                >
                                Cancel
                            </Button>
                            <Button
                                width='12.6' borderColor='#4C6FFF' height='3.6'
                                hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                                radius="0.6" titleSize="1.2"
                            >
                                Send message
                            </Button>
                        </FlexRow>
                    </FlexColumn>
                </Form>
            </FixedContainer>
        </>
    )
}